'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { AuthState } from '../stores/authStore';
import { createAuthStore } from '../stores/authStore';

export type AuthStoreApi = ReturnType<typeof createAuthStore>;

export type AuthStoreProviderProps = {
    children: ReactNode;
    authState?: AuthState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AuthStoreContext = createContext<AuthStoreApi | undefined>(undefined);

export function AuthStoreProvider({ children, authState }: AuthStoreProviderProps): JSX.Element {
    const storeRef = useRef<AuthStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createAuthStore(authState);
    }

    return <AuthStoreContext.Provider value={storeRef.current}>{children}</AuthStoreContext.Provider>;
}
